import { NgModule } from '@angular/core';
import { IconButtonModule } from 'projects/workspace/src/app/shared/directives/icon-button/icon-button.module';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatExpansionModule, MatMenuModule } from '@angular/material';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgOtpInputModule } from 'ng-otp-input';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgxCurrencyModule } from 'ngx-currency-custom';
import { TranslateModule } from '@ngx-translate/core';
import { NgxPrintModule } from 'ngx-print';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { NgxMaskModule } from 'ngx-mask';

import { UIComponentsModule } from '../ui-components/ui-components.module';
import { RnplCommonModule } from '../rnpl-common';
import { HrmModule } from 'projects/workspace/src/app/hrm/hrm.module';
import { ProductFormHardcodeModule } from '../products';
import { DynamicFormsModule, UsersCommonModule } from '..';

import {
  ChangeEmailModalComponent,
  ChangePasswordModalComponent,
  CreateNewEmployeeModalComponent,
} from './modals-hrm';
import {
  CreateNewWarehouseModalComponent,
  CreateNewBinLocationModalComponent,
} from './modals-warehouse';
import {
  CreateSoModalComponent,
  PoPositionModalComponent,
} from './modals-purchase-order';
import { PurchaseOrderModule } from 'projects/workspace/src/app/purchase-order/purchase-order.module';
import { SignInModalComponent } from './modals-sign-in';
import { CommonPagesModule } from '../../pages/common-pages.module';
import {
  OfferAddDiscountModalComponent,
  OfferBillingInfoModalComponent,
  OfferDeliveryInfoModalComponent,
  OfferPositionModalComponent,
  TradeOfferModalHintsComponent,
  OfferEditPositionModalComponent,
} from './modals-trade-offer';
import { TradeOfferApiService } from 'projects/workspace/src/app/trade-offer/services/trade-offer-api.service';
import {
  CreateNewPartnerModalComponent,
  CreateNewContactModalComponent,
  CreateNewPrivatePartnerModalComponent, CreateBranchOfficeModalComponent
} from './modals-crm';
import { PartnerFormModule } from 'projects/workspace/src/app/crm/components/partner-form/partner-form.module';
import {
  CorporatePartnerFormModule
} from 'projects/workspace/src/app/crm/partner-forms/components/corporate-partner-form/corporate-partner-form.module';
import { AddressFormModule } from 'projects/workspace/src/app/crm/partner-forms/components/address-form/address-form.module';
import {
  OutgoingInvoiceSelectPartnerModalComponent,
  OutgoingInvoiceEditPositionModalComponent,
  OutgoingInvoiceAddDiscountModalComponent,
  OutgoingInvoiceBillingInfoModalComponent,
  OutgoingInvoiceLinkSalesOrderModalComponent,
  OutgoingInvoicePositionModalComponent,
  OutgoingInvoiceModalHintsComponent,
} from './modals-outgoing-invoice';
import {
  ConfirmModalComponent,
  DangerModalComponent,
  InfoModalComponent,
  SendEmailModalComponent,
  WarningModalComponent,
  SkipHintModalComponent,
  AddPdfTextModalComponent,
  SavePdfTextTemplateModalComponent,
  AllocatePaymentModalComponent,
  CreateDownPaymentModalComponent,
  PositionGroupModalComponent,
  RemarkModalComponent,
  MoveToGroupModalComponent,
  SepaIdModalComponent,
  SepaExecutionDateModalComponent,
  UpgradePlanModalComponent,
  AddVatRateModalComponent,
} from './modals-common';
import {
  ProductVariationModalComponent,
  CategoryModalComponent,
  CompositeProductModalComponent,
  FamilyAssignedAttrModalComponent,
  MoveProductsModalComponent,
  MoveSingleProductModalComponent,
  ProductRelationModalComponent,
  ProductPriceModalComponent,
  FamilyAssignedModalHintsComponent,
  CompositeProductHintsComponent,
  ProductVariationViewModalComponent,
  CreateProductTypeUnitModalComponent,
  AddBundleProductModalComponent,
} from './modals-products';
import { SalesOrderApiService } from 'projects/workspace/src/app/sales-order/services/sales-order-api.service';
import {
  CreatePoModalComponent,
  ForceCompleteSoModalComponent,
  LinkOfferModalComponent,
  ResolveConflictModalComponent,
  SalesOrderConfirmServicesModalComponent,
  SalesOrderPositionModalComponent,
  SalesOrderEditPositionModalComponent,
  SalesOrderAddDiscountModalComponent,
  SalesOrderDeliveryInfoModalComponent,
  SalesOrderBillingInfoModalComponent,
  SoSelectPartnerModalComponent
} from './modals-sales-order';
import { TradeApiService } from 'projects/workspace/src/app/trade';
import { WizardService } from '../wizard';
import { LinkDocumentModalComponent } from './modals-common/link-document-modal/link-document-modal.component';
import { WarehouseModule } from 'projects/workspace/src/app/warehouse/warehouse.module';
import { PackUpModalComponent } from './modals-warehouse/pack-up-modal/pack-up-modal.component';
import {
  PuckUpModalComponent,
  GeneratePickListModalComponent,
  GeneratePickListErrorModalComponent,
  AddProductModalComponent,
  PrereservationModalComponent,
  AddProductForLinkedModalComponent,
  PackUpShipmentSuccessModalComponent,
  PackUpShipmentModalComponent,
  SelectPartnerModalComponent,
  EditProductModalComponent,
  DeliveryInfoModalComponent
} from './modals-delivery-note';
import {
  DeliveryNoteUnitsFormModule
} from 'projects/workspace/src/app/delivery-note/components/delivery-note-units-form/delivery-note-units-form.module';
import {
  BlankIinModalComponent,
  CreateIinModalComponent,
  IncomingInvoicePositionModalComponent,
  LinkPurchaseOrderModalComponent,
  LinkScheduledPaymentModalComponent,
  ParseIinModalComponent
} from './modals-incoming-invoice';
import {
  CreditNoteCommonPositionModalComponent,
  CreditNoteCreateModalComponent,
  CreditNotePositionModalComponent,
} from './modals-credit-note';
import { LinkSalesOrderComponent } from './modals-common/link-sales-order/link-sales-order.component';
import { RouterModule } from '@angular/router';
import { SubscriptionPositionModalComponent, SubscriptionPauseModalComponent } from './modals-subscription';
import { SubscriptionApiService } from 'projects/workspace/src/app/subscription/services/subscription-api.service';
import { PartnersApiService } from 'projects/workspace/src/app/partners/corporate/services/partner-api.service';
import { PrivatePartnersApiService } from 'projects/workspace/src/app/partners/private/services/partner-api.service';
import { ExchangeAddProductModalNewComponent } from './modals-exchange';
import { ExchangeApiService } from 'projects/workspace/src/app/exchange/services/exchange-api.service';
import {
  TimeTrackingAssignSalesOrderModalComponent,
  TimeTrackingBillingScheduleModalComponent,
  TimeTrackingBillTimeModalComponent,
  TimeTrackingExportListModalComponent,
  TimeTrackingGroupingFormComponent,
  TimeTrackingGroupingModalComponent,
  TimeTrackingLogTimeModalComponent,
  TimeTrackingResolveIssueModalComponent
} from './modals-time-tracking';
import { SafePipeModule } from 'safe-pipe';
import {
  EcoAddDiscountModalComponent,
  EcommerceOrderPositionModalComponent,
  EcommerceProductPriceModalComponent,
  EcoProductsActivationModalComponent
} from './modals-ecommerce';
import {
  AddBannerModalComponent,
  AddCategoryModalComponent,
  CardPaymentsStripeModalComponent,
  SliderModalComponent,
  UpdateBlockColorModalComponent,
  UpdateCardPaymentsModalComponent,
  UpdateDeliveryTermModalComponent,
  UpdatePurchaseOnInvoiceModalComponent,
  UpdateReturnsTermModalComponent
} from './modals-ecommerce-settings';
import {
  IncomingDeliveryCancelWarehousingModalComponent,
  IncomingDeliveryProductsReceiptModalComponent,
  IncomingDeliveryProductsReturnModalComponent,
  IncomingDeliveryWarehousingModalComponent
} from './modals-incoming-delivery';
import { CreateNewTransactionModalComponent } from './modals-transactions';
import { ChangePasswordComponent } from './modals-sign-in/change-password/change-password.component';
import {
  ReportingPeriodsCloseByYearModalComponent,
  ReportingPeriodsReportPeriodModalComponent,
  ReportingPeriodsSetupExternalModalComponent
} from './modals-reporting-periods';
import { NewTransactionsHintsComponent } from './modals-transactions/new-transactions-hints/new-transactions-hints.component';
import { ProductReceiptHintsComponent } from './modals-incoming-delivery/product-receipt-hints/product-receipt-hints.component';
import { WarehousingHintsComponent } from './modals-incoming-delivery/warehousing-hints/warehousing-hints.component';
import { PackUpHintsComponent } from './modals-warehouse/pack-up-modal/pack-up-hints/pack-up-hints.component';
import { LogTimeModalsHintsComponent } from './modals-time-tracking/log-time-modals-hints/log-time-modals-hints.component';
import { BillTimeHintsComponent } from './modals-time-tracking/bill-time-hints/bill-time-hints.component';
import { GroupingModalHintsComponent } from './modals-time-tracking/grouping-modal-hints/grouping-modal-hints.component';
import { PauseModalsHintsComponent } from './modals-subscription/pause-modals-hints/pause-modals-hints.component';
import { PositionModalsHintsComponent } from './modals-outgoing-invoice/position-modals-hints/position-modals-hints.component';
import { CreateOinImportModalComponent } from 'projects/workspace/src/app/outgoing-invoice/modals';
import { DocumentNumberSettingsModule } from 'projects/workspace/src/app/shared/forms/document-number-settings/document-number-settings.module';
import { CreditNotePositionHintsComponent } from './modals-credit-note/credit-note-position-hints/credit-note-position-hints.component';
import { AddProductHintsComponent } from './modals-exchange/add-product-hints/add-product-hints.component';
import { CreatePartnerHintsComponent } from './modals-crm/create-partner-hints/create-partner-hints.component';
import { CreateNewUserHintsComponent } from './modals-hrm/create-new-user-hints/create-new-user-hints.component';
import { InfoHintsCardModule } from '../info-hints-card/info-hints-card.module';
import {
  ActivateSubscriptionModalComponent,
  CancelSubscriptionModalComponent,
  DeleteAccountModalComponent,
  UpdatePaymentCardModalComponent
} from './modals-subscription-activation';
import { ConnectBankAccountModalComponent, CreateNewBankAccountModalComponent, SyncPaymentsModalComponent } from './modals-bank-accounts';
import { BankAccountFormModule } from 'projects/workspace/src/app/bank-accounts/forms';
import {
  AccountingSettingsSendEmailModalComponent,
  GlAllocationRuleModalComponent,
  OinSendNoticeEmailModalComponent
} from './modals-accounting-settings';
import { OverdueNoticeFormModule } from 'projects/workspace/src/app/accounting/accounting-settings-module/forms';
import { ShortcutsModalComponent } from './modals-control-center';
// import { LaunchpadModalComponent } from './launchpad-modal/launchpad-modal.component';
import {
  AddDocumentModalComponent,
  LinkMultiplePaymentsModalComponent,
  LinkSpModalComponent,
  UnlinkDocumentModalComponent,
} from './modals-payments';
import { PositionCardModule } from '../position-card/position-card.module';
import {
  AustrianPostSettingsModalComponent,
  DhlSettingsModalComponent,
  GlsSettingsModalComponent,
  UpsSettingsModalComponent
} from './modals-delivery-services';
import {
  EcoDeliveryFormModule
} from 'projects/workspace/src/app/e-commerce/modules/ecommerce-settings/forms/eco-delivery-form/eco-delivery-form.module';
import {
  ScheduledPaymentPositionModalComponent,
  ScheduledPaymentScheduleFormModalComponent,
  ScheduledPaymentsLinkModalComponent
} from './modals-scheduled-payment';
import {
  ScheduledPaymentBillingScheduleFormModule
} from 'projects/workspace/src/app/scheduled-payment/components';
import { SidebarModule } from 'projects/workspace/src/app/shared/components/sidebar/sidebar.module';
import { PricesTableTotalInfoModule } from 'projects/workspace/src/app/trade-prices/components';
import { DiscountFormModule } from 'projects/workspace/src/app/shared/forms/discount-form/discount-form.module';
import { CommonAddressFormModule } from 'projects/workspace/src/app/shared/forms/common-address-form/common-address-form.module';
import { DeliveryCostFormModule } from 'projects/workspace/src/app/shared/forms/delivery-cost-form/delivery-cost-form.module';
import { InsuranceCostFormModule } from 'projects/workspace/src/app/shared/forms/insurance-cost-form/insurance-cost-form.module';
import { DueWithinFormModule } from 'projects/workspace/src/app/shared/forms/due-within-form/due-within-form.module';
import { ScontoFormModule } from 'projects/workspace/src/app/shared/forms/sconto-form/sconto-form.module';
import { OfferSelectPartnerModalComponent } from './modals-trade-offer/offer-select-partner-modal/offer-select-partner-modal.component';
import { CreditNoteSelectPartnerModalComponent } from './modals-credit-note';
import { CreditNoteEditPositionModalComponent } from './modals-credit-note';
import { CreaditNoteBillingInfoModalComponent } from './modals-credit-note';
import { SbcSelectPartnerModalComponent } from './modals-subscription';
import { SubscriptionEditPositionModalComponent } from './modals-subscription';
import { SubscriptionAddDiscountModalComponent } from './modals-subscription';
import { SubscriptionAddBillingInfoModalComponent } from './modals-subscription';
import { AddressCardModule } from 'projects/workspace/src/app/shared/components/address-card/address-card.module';
import { SalesOrderModalHintsComponent } from './modals-sales-order/sales-order-modal-hints/sales-order-modal-hints.component';
import { SubscriptionModalHintsComponent } from './modals-subscription/subscription-modal-hints/subscription-modal-hints.component';
import { EcoBillingInfoModalComponent } from './modals-ecommerce/eco-billing-info-modal/eco-billing-info-modal.component';
import { CompanyNameControlModule } from 'projects/workspace/src/app/shared/forms/company-name-control/company-name-control.module';
import { EcoEditPositionModalComponent } from './modals-ecommerce/eco-edit-position-modal/eco-edit-position-modal.component';
import { EcoDeliveryInfoModalComponent } from './modals-ecommerce/eco-delivery-info-modal/eco-delivery-info-modal.component';
import { EcoAddPartnerModalComponent } from './modals-ecommerce/eco-add-partner-modal/eco-add-partner-modal.component';
import { LaunchPadAddShortcutsModalComponent } from './launch-pad-add-shortcuts-modal/launch-pad-add-shortcuts-modal.component';
import { QuickActionsModalComponent } from './quick-actions-modal/quick-actions-modal.component';
// import { StartScreenPageModule } from '../start-screen-page/start-screen-page.module';
import {
  IncomingInvoiceOcrErrorModalComponent
} from './modals-incoming-invoice/incoming-invoice-ocr-error-modal/incoming-invoice-ocr-error-modal.component';
import {
  DocumentTemplateSameNameModalComponent,
  DocumentTemplateSaveModalComponent,
  DocumentTemplatesModalComponent
} from './modals-documents-templates';
import { DocumentsTemplatesApiService, PositionGroupsService } from 'projects/workspace/src/app/shared/services';
import { AutocorrectionModalComponent } from './modals-common/autocorrection-modal/autocorrection-modal.component';
import { CreateNewGlAccountModalComponent } from './modals-gl-accounts';
import { ExpansionPanelModule } from 'projects/workspace/src/app/shared/components/expansion-panel/expansion-panel.module';
import { GlAccountDropdownModule, GlProductTypeDropdownModule } from 'projects/workspace/src/app/gl-accounts/components';
import {
  ModalContainerModule,
  PositionAccountingSettingsModule,
  PositionsNavigateButtonsModule,
  RelatedProductsCardsModule,
  BundledProductsCardsModule,
  TextEditorModule
} from 'projects/workspace/src/app/shared/components';
import { PurposeFormModule } from 'projects/workspace/src/app/shared/forms/purpose-form/purpose-form.module';
import { LogoModule } from '../ui-components/logo/logo.module';
import { NumberFormatPipeModule } from 'projects/workspace/src/app/shared/pipes/number-format-pipe/number-format-pipe.module';
import {
  DueWithinDateFormModule,
  EmailTextFormModule,
  ProductVariationsControlModule,
  BankAccountDocumentFormModule,
  DeliveryServiceControlModule,
  SalesPriceListControlModule,
  PositionMediaFormModule,
  VatRatesDropdownModule
} from 'projects/workspace/src/app/shared/forms';
import { CreateProductFormHardcodeModule } from '../products/product-form-hardcode/create-product/create-product-form-hardcode.module';
import { DataImportApiService } from 'projects/workspace/src/app/data-import/data-import-api.service';
import {
  DataImportModalComponent,
  DataImportPartnerAccountsModalComponent,
  DataImportPaymentsModalComponent,
  DataImportProductTypeModalComponent,
  DataImportSalesPriceModalComponent
} from './modals-data-import';
import { DownloadTemplateModule } from 'projects/workspace/src/app/data-import/components';
import { AddTaxCodeModalComponent, CreateVatReportModalComponent } from './modals-vat-reports';
import { VatReportsApiService } from 'projects/workspace/src/app/vat-reports/services/vat-reports-api.service';
import { AccountingReportsSettingsService } from 'projects/workspace/src/app/accounting/accounting-settings-module/services';
import { AutoResizeTextareaModule } from 'projects/workspace/src/app/shared/directives';
import { CreateGeneralProductModalComponent } from './modals-products/create-general-product-modal/create-general-product-modal.component';
import { GeneralLedgerApiService } from 'projects/workspace/src/app/gl-accounts/services/general-ledger-api.service';


const DATA_IMPORT_MODALS = [
  DataImportModalComponent,
  DataImportPaymentsModalComponent,
  DataImportProductTypeModalComponent,
  DataImportSalesPriceModalComponent,
  DataImportPartnerAccountsModalComponent,
];

const PAYMENTS_MODALS = [
  LinkMultiplePaymentsModalComponent,
  AddDocumentModalComponent,
  LinkSpModalComponent,
  UnlinkDocumentModalComponent,
];

const GL_ACCOUNTS_MODALS = [
  CreateNewGlAccountModalComponent
];

const BANK_ACCOUNTS_MODALS = [
  CreateNewBankAccountModalComponent,
  ConnectBankAccountModalComponent,
  SyncPaymentsModalComponent
];

const DELIVERY_SERVICES_MODALS = [
  AustrianPostSettingsModalComponent,
  DhlSettingsModalComponent,
  GlsSettingsModalComponent,
  UpsSettingsModalComponent,
];

const SUBSCRIPTION_ACTIVATION_MODALS = [
  ActivateSubscriptionModalComponent,
  CancelSubscriptionModalComponent,
  UpdatePaymentCardModalComponent,
  DeleteAccountModalComponent,
];

const ACCOUNTING_SETTINGS_MODALS = [
  AccountingSettingsSendEmailModalComponent,
  OinSendNoticeEmailModalComponent,
  GlAllocationRuleModalComponent,
];

const REPORTING_PERIODS_MODALS = [
  ReportingPeriodsReportPeriodModalComponent,
  ReportingPeriodsCloseByYearModalComponent,
  ReportingPeriodsSetupExternalModalComponent,
];

const TRANSACTIONS_MODALS = [
  CreateNewTransactionModalComponent
];

const SCHEDULED_PAYMENT_MODALS = [
  ScheduledPaymentPositionModalComponent,
  ScheduledPaymentsLinkModalComponent,
  ScheduledPaymentScheduleFormModalComponent
];

const INCOMING_DELIVERY_MODALS = [
  IncomingDeliveryProductsReceiptModalComponent,
  IncomingDeliveryProductsReturnModalComponent,
  IncomingDeliveryWarehousingModalComponent,
  IncomingDeliveryCancelWarehousingModalComponent
];

const ECOMMERCE_MODALS = [
  EcommerceProductPriceModalComponent,
  EcommerceOrderPositionModalComponent,
  EcoProductsActivationModalComponent,
  EcoBillingInfoModalComponent,
  EcoDeliveryInfoModalComponent,
  EcoAddPartnerModalComponent,
  EcoAddDiscountModalComponent,
  EcoEditPositionModalComponent,
];

const ECOMMERCE_SETTINGS_MODALS = [
  AddBannerModalComponent,
  AddCategoryModalComponent,
  SliderModalComponent,
  UpdateDeliveryTermModalComponent,
  UpdateReturnsTermModalComponent,
  UpdatePurchaseOnInvoiceModalComponent,
  UpdateCardPaymentsModalComponent,
  CardPaymentsStripeModalComponent,
  UpdateBlockColorModalComponent,
];

const EXCHANGE_MODALS = [
  ExchangeAddProductModalNewComponent,
];

const TIME_TRACKING_MODALS = [
  TimeTrackingLogTimeModalComponent,
  TimeTrackingBillTimeModalComponent,
  TimeTrackingBillingScheduleModalComponent,
  TimeTrackingAssignSalesOrderModalComponent,
  TimeTrackingResolveIssueModalComponent,
  TimeTrackingGroupingFormComponent,
  TimeTrackingGroupingModalComponent,
  TimeTrackingExportListModalComponent,
];

const CREDIT_NOTE_MODALS = [
  CreditNotePositionModalComponent,
  CreditNoteCommonPositionModalComponent,
  CreditNoteSelectPartnerModalComponent,
  CreditNoteEditPositionModalComponent,
  CreaditNoteBillingInfoModalComponent,
  CreditNoteCreateModalComponent,
];

const DELIVERY_NOTE_MODALS = [
  PuckUpModalComponent,
  GeneratePickListModalComponent,
  GeneratePickListErrorModalComponent,
  AddProductModalComponent,
  PrereservationModalComponent,
  AddProductForLinkedModalComponent,
  PackUpShipmentSuccessModalComponent,
  PackUpShipmentModalComponent,
  SelectPartnerModalComponent,
  EditProductModalComponent,
  DeliveryInfoModalComponent,
];

const PRODUCTS_MODALS = [
  CompositeProductModalComponent,
  FamilyAssignedAttrModalComponent,
  CategoryModalComponent,
  ProductPriceModalComponent,
  MoveProductsModalComponent,
  MoveSingleProductModalComponent,
  ProductRelationModalComponent,
  ProductVariationModalComponent,
  ProductVariationViewModalComponent,
  FamilyAssignedModalHintsComponent,
  CompositeProductHintsComponent,
  CreateProductTypeUnitModalComponent,
  CreateGeneralProductModalComponent,
  AddBundleProductModalComponent,
];

const TRADE_OFFER_MODALS = [
  OfferPositionModalComponent,
  OfferSelectPartnerModalComponent,
  OfferEditPositionModalComponent,
  OfferAddDiscountModalComponent,
  OfferBillingInfoModalComponent,
  OfferDeliveryInfoModalComponent,
];

const SUBSCRIPTION_MODALS = [
  SubscriptionPositionModalComponent,
  SubscriptionPauseModalComponent,
  SbcSelectPartnerModalComponent,
  SubscriptionEditPositionModalComponent,
  SubscriptionAddDiscountModalComponent,
  SubscriptionAddBillingInfoModalComponent,
];

const SALES_ORDER_MODALS = [
  ResolveConflictModalComponent,
  SalesOrderPositionModalComponent,
  LinkOfferModalComponent,
  SalesOrderConfirmServicesModalComponent,
  CreatePoModalComponent,
  ForceCompleteSoModalComponent,
  SoSelectPartnerModalComponent,
  SalesOrderEditPositionModalComponent,
  SalesOrderAddDiscountModalComponent,
  SalesOrderDeliveryInfoModalComponent,
  SalesOrderBillingInfoModalComponent,
];

const PURCHASE_ORDER_MODALS = [
  PoPositionModalComponent,
  CreateSoModalComponent
];

const HRM_MODALS = [
  ChangeEmailModalComponent,
  ChangePasswordModalComponent,
  CreateNewEmployeeModalComponent,
];

const CRM_MODALS = [
  CreateNewPartnerModalComponent,
  CreateNewContactModalComponent,
  CreateNewPrivatePartnerModalComponent,
  CreateBranchOfficeModalComponent
];

const OUTGOING_INVOICE_MODALS = [
  OutgoingInvoicePositionModalComponent,
  OutgoingInvoiceLinkSalesOrderModalComponent,
  OutgoingInvoiceSelectPartnerModalComponent,
  OutgoingInvoiceEditPositionModalComponent,
  OutgoingInvoiceAddDiscountModalComponent,
  OutgoingInvoiceBillingInfoModalComponent,
  CreateOinImportModalComponent,
];

const INCOMING_INVOICE_MODALS = [
  IncomingInvoicePositionModalComponent,
  IncomingInvoiceOcrErrorModalComponent,
  LinkPurchaseOrderModalComponent,
  LinkScheduledPaymentModalComponent,
  CreateIinModalComponent,
  BlankIinModalComponent,
  ParseIinModalComponent,
];

const WAREHOUSE_MODALS = [
  CreateNewWarehouseModalComponent,
  PackUpModalComponent,
  CreateNewBinLocationModalComponent
];

const SIGN_IN_MODALS = [
  SignInModalComponent,
];

const COMMON_MODALS = [
  ConfirmModalComponent,
  WarningModalComponent,
  DangerModalComponent,
  LinkDocumentModalComponent,
  InfoModalComponent,
  LinkSalesOrderComponent,
  SendEmailModalComponent,
  AutocorrectionModalComponent,
  AddPdfTextModalComponent,
  SavePdfTextTemplateModalComponent,
  AllocatePaymentModalComponent,
  CreateDownPaymentModalComponent,
  RemarkModalComponent,
  PositionGroupModalComponent,
  MoveToGroupModalComponent,
  SepaIdModalComponent,
  SepaExecutionDateModalComponent,
  UpgradePlanModalComponent,
  AddVatRateModalComponent,
];

const DOCUMENTS_TEMPLATES_MODALS = [
  DocumentTemplatesModalComponent,
  DocumentTemplateSaveModalComponent,
  DocumentTemplateSameNameModalComponent
];

const VAT_REPORTS_MODALS = [
  CreateVatReportModalComponent,
  AddTaxCodeModalComponent,
];

const MODALS = [
  ...PAYMENTS_MODALS,
  ...DELIVERY_NOTE_MODALS,
  ...WAREHOUSE_MODALS,
  ...HRM_MODALS,
  ...PURCHASE_ORDER_MODALS,
  ...SIGN_IN_MODALS,
  ...TRADE_OFFER_MODALS,
  ...SALES_ORDER_MODALS,
  ...CRM_MODALS,
  ...OUTGOING_INVOICE_MODALS,
  ...COMMON_MODALS,
  ...PRODUCTS_MODALS,
  ...INCOMING_INVOICE_MODALS,
  ...CREDIT_NOTE_MODALS,
  ...SUBSCRIPTION_MODALS,
  ...EXCHANGE_MODALS,
  ...TIME_TRACKING_MODALS,
  ...ECOMMERCE_MODALS,
  ...ECOMMERCE_SETTINGS_MODALS,
  ...INCOMING_DELIVERY_MODALS,
  ...TRANSACTIONS_MODALS,
  ...REPORTING_PERIODS_MODALS,
  ...SUBSCRIPTION_ACTIVATION_MODALS,
  ...BANK_ACCOUNTS_MODALS,
  ...GL_ACCOUNTS_MODALS,
  ...ACCOUNTING_SETTINGS_MODALS,
  ...DELIVERY_SERVICES_MODALS,
  ...DOCUMENTS_TEMPLATES_MODALS,
  ...DATA_IMPORT_MODALS,
  ...VAT_REPORTS_MODALS,
  SkipHintModalComponent,
  ShortcutsModalComponent,
  // LaunchpadModalComponent,
  ...SCHEDULED_PAYMENT_MODALS,
  LaunchPadAddShortcutsModalComponent,
  QuickActionsModalComponent,
];

@NgModule({
  declarations: [
    ...MODALS,
    ChangePasswordComponent,
    NewTransactionsHintsComponent,
    ProductReceiptHintsComponent,
    WarehousingHintsComponent,
    PackUpHintsComponent,
    LogTimeModalsHintsComponent,
    BillTimeHintsComponent,
    GroupingModalHintsComponent,
    PauseModalsHintsComponent,
    PositionModalsHintsComponent,
    CreditNotePositionHintsComponent,
    AddProductHintsComponent,
    CreatePartnerHintsComponent,
    CreateNewUserHintsComponent,
    TradeOfferModalHintsComponent,
    SalesOrderModalHintsComponent,
    SubscriptionModalHintsComponent,
    OutgoingInvoiceModalHintsComponent,
  ],
  exports: [...MODALS],
  imports: [
    IconButtonModule,
    CommonModule,
    UIComponentsModule,
    MatMenuModule,
    MatExpansionModule,
    RnplCommonModule,
    WarehouseModule,
    HrmModule,
    PurchaseOrderModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgSelectModule,
    NgxCurrencyModule,
    DynamicFormsModule,
    CommonPagesModule,
    NgOtpInputModule,
    PartnerFormModule,
    CorporatePartnerFormModule,
    AddressFormModule,
    ProductFormHardcodeModule,
    CreateProductFormHardcodeModule,
    DragDropModule,
    DeliveryNoteUnitsFormModule,
    SafePipeModule,
    UsersCommonModule,
    TranslateModule,
    InfoHintsCardModule,
    BankAccountFormModule,
    OverdueNoticeFormModule,
    PositionCardModule,
    EcoDeliveryFormModule,
    BankAccountDocumentFormModule,
    ScheduledPaymentBillingScheduleFormModule,
    PositionCardModule,
    MatDialogModule,
    SidebarModule,
    PricesTableTotalInfoModule,
    DiscountFormModule,
    CommonAddressFormModule,
    DeliveryCostFormModule,
    InsuranceCostFormModule,
    DueWithinFormModule,
    DueWithinDateFormModule,
    ScontoFormModule,
    PositionCardModule,
    AddressCardModule,
    EcoDeliveryFormModule,
    CompanyNameControlModule,
    PositionCardModule,
    NgxPrintModule,
    // StartScreenPageModule,
    PositionsNavigateButtonsModule,
    GooglePlaceModule,
    ExpansionPanelModule,
    GlAccountDropdownModule,
    GlProductTypeDropdownModule,
    PositionAccountingSettingsModule,
    PurposeFormModule,
    DeliveryServiceControlModule,
    PerfectScrollbarModule,
    NgxMaskModule,
    LogoModule,
    ModalContainerModule,
    NumberFormatPipeModule,
    EmailTextFormModule,
    ProductVariationsControlModule,
    RelatedProductsCardsModule,
    BundledProductsCardsModule,
    SalesPriceListControlModule,
    DownloadTemplateModule,
    AutoResizeTextareaModule,
    TextEditorModule,
    PositionMediaFormModule,
    VatRatesDropdownModule,
    DocumentNumberSettingsModule,
  ],
  entryComponents: [...MODALS],
  providers: [
    TradeOfferApiService,
    SalesOrderApiService,
    TradeApiService,
    WizardService,
    SubscriptionApiService,
    PartnersApiService,
    PrivatePartnersApiService,
    ExchangeApiService,
    DocumentsTemplatesApiService,
    DataImportApiService,
    VatReportsApiService,
    AccountingReportsSettingsService,
    PositionGroupsService,
    GeneralLedgerApiService
  ]
})
export class ModalsModule { }
